import React from 'react';
import ReactDOM from 'react-dom/client';

import './global.scss';
import App from './App';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const isIframe = window.location !== window.parent.location;

if (!(isIframe))
  window.location.href = (window as any)["env"]["sourcingUrl"];
else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
